import cookieHelper from "../paymentMethods/src/helpers/cookieHelper";

var AFIP = AFIP || {};

AFIP.mapProvince = function(idProvincia) {
    switch (idProvincia){
        case 0:
            return "caba";
        case 1:
            return "buenos_aires"
        case 2:
            return "catamarca"
        case 3:
            return "cordoba";
        case 4:
            return "corrientes";
        case 5:
            return "entre_rios";
        case 6:
            return "jujuy";
        case 7:
            return "mendoza";
        case 8:
            return "la_rioja";
        case 9:
            return "salta";
        case 10:
            return "san_juan";
        case 11:
            return "san_luis";
        case 12:
            return "santa_fe";
        case 13:
            return "santiago_del_estero";
        case 14:
            return "tucuman";
        case 15:
            return "neuquen";
        case 16:
            return "chaco";
        case 17:
            return "chubut";
        case 18:
            return "formosa";
        case 19:
            return "misiones";
        case 20:
            return "neuquen";
        case 21:
            return "la_pampa";
        case 22:
            return "rio_negro";
        case 23:
            return "santa_cruz";
        case 24:
            return  "tierra_del_fuego";
        default:
            return "";
    }
}

export default AFIP;


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/afip.js